// import Head from "next/head";

// export default function MetaDefaults() {
//   return (
//     <Head>
//       {/* Default Title */}
//       <title>Sigma Machines | CNC & Industrial Machinery</title>

//       {/* Default Meta */}
//       <meta
//         name="description"
//         content="Sigma Machines specializes in CNC machines, fiber laser cutters, routers, welding systems, and industrial machinery across Saudi Arabia and the Middle East."
//       />
//       <meta
//         name="keywords"
//         content="
//           CNC machines Saudi Arabia,
//           CNC router supplier,
//           Fiber laser machines KSA,
//           Industrial machinery distributor,
//           Laser cutting machines,
//           CNC machines Middle East
//         "
//       />

//       {/* OG Defaults */}
//       <meta property="og:title" content="Sigma Machines" />
//       <meta
//         property="og:description"
//         content="High-performance CNC and industrial machinery with professional after-sales service."
//       />
//       <meta property="og:image" content="https://sigmamachines.net/logo.png" />
//       <meta property="og:site_name" content="Sigma Machines" />

//       {/* Twitter */}
//       <meta name="twitter:card" content="summary_large_image" />
//       <meta name="twitter:image" content="https://sigmamachines.net/logo.png" />

//       <link rel="icon" href="/favicon.ico" />
//     </Head>
//   );
// }

import Head from "next/head";

export default function MetaDefaults() {
  return (
    <Head>
      <title>سيجما لماكينات الـ CNC والفايبر ليزر في السعودية | Sigma Machines</title>

      <meta
        name="description"
        content="شركة سيجما توريد وصيانة ماكينات CNC، فايبر ليزر قص معادن، وراوتر بالرياض، جدة، والدمام. نوفر قطع غيار أصلية ومصادر ليزر Raycus بأفضل الأسعار في السعودية."
      />

      <meta
        name="keywords"
        content="
          ماكينات فايبر ليزر في السعودية,
          أسعار ماكينات CNC في السعودية,
          ماكينة راوتر CNC الرياض,
          قص معادن بالليزر جدة,
          مكبس ثني CNC الدمام,
          قطع غيار ماكينات CNC السعودية,
          صيانة ماكينات ليزر بالرياض,
          مصدر ليزر Raycus السعودية,
          شراء ماكينة قص معادن بالليزر,
          Sigma Machines KSA
        "
      />

      <meta property="og:title" content="سيجما لماكينات الـ CNC والفايبر ليزر في السعودية" />
      <meta
        property="og:description"
        content="حلول متكاملة لتأسيس المصانع: توريد، تركيب، وصيانة ماكينات قص المعادن والراوتر وقطع الغيار في المملكة العربية السعودية."
      />
      <meta property="og:image" content="https://sigmamachines.net/logo.png" />
      <meta property="og:site_name" content="Sigma Machines" />
      <meta property="og:locale" content="ar_SA" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="سيجما لماكينات الـ CNC والفايبر ليزر في السعودية" />
      <meta
        name="twitter:description"
        content="تأسيس وتجهيز المصانع بأحدث ماكينات الـ CNC والفايبر ليزر مع الصيانة وقطع الغيار في السعودية."
      />
      <meta name="twitter:image" content="https://sigmamachines.net/logo.png" />

      <link rel="icon" href="/favicon.ico" />
    </Head>
  );
}